/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Settings_TitleInputs */



/**
* | output |
* | --- |
* | "Timing & Sync Settings" |
*
* @param {Timing_Sync_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_settings_title = /** @type {((inputs?: Timing_Sync_Settings_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Settings_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Parametres de minutage et synchronisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeit- und Synchronisierungseinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni di temporizzazione e sincronizzazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки времени и синхронизации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de tiempo y sincronización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("定时和同步设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイミングと同期の設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय और सिंक सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de tempo e sincronização")
	return /** @type {LocalizedString} */ ("Timing & Sync Settings")
});